<!-- spin if user is loading//-->
@if ((userLoading$ | async)) {
  <div class="page-center">
    <mat-icon class="icon-spin">progress_activity</mat-icon>&nbsp;Einen kurzen Moment bitte. Ihre Benutzerdaten werden
    geladen.
  </div>
}

<!-- load content if user loading has finished and user is authenticated //-->
@if (!(userLoading$ | async) && authenticated) {
  <div id="app">
    <div id="view" class="d-flex flex-column mx-m">
      <app-nav></app-nav>
      <div class="main-grid" id="visible-view">
        <aside class="leftsky">
          <app-skyscraper position="left"></app-skyscraper>
        </aside>
        <div id="main-content">
          <app-notices></app-notices>
          <ng-container>
            <router-outlet></router-outlet>
          </ng-container>
          <app-footer></app-footer>
        </div>
        <aside class="rightsky">
          <app-skyscraper position="right"></app-skyscraper>
        </aside>
      </div>
      <app-dialog-popup></app-dialog-popup>
    </div>
    @if (isOnDashboard()) {
      <app-sticky></app-sticky>
    }
  </div>
}

<app-chatbot-mini [path]="currentRoute"></app-chatbot-mini>